module.exports = __webpack_public_path__ + "img/1F641.f8dded36.svg";